<fieldset id="grupo{{grupo}}">
  <div class="radiocustom radiobuttonFormulario" [ngClass]="{'soloLectura' : disabled, 'izquierda' : alineacion == AlineacionEnum.Izquierda, 'derecha' : alineacion == AlineacionEnum.Derecha, 'sinMargen' : sinMargen}">

    <div clas="radiobuttonInput">
      <div class="formaradiobutton" tabindex="0" (keypress)="TeclaPresionada($event)" >
        <input type="radio" id="radiobuttoncustom{{id}}" [(ngModel)]="valor"(ngModelChange)="change($event)" [value]="radioValor" name="grupo{{grupo}}"/>
        <label class="radiobuttonLabel" for="radiobuttoncustom{{id}}"> {{titulo}}</label>
      </div>
    </div>
  </div>
</fieldset>


